import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useActivityTDK } from './use-activity-tdk';
import { url } from '.';
import { CommonPageOGCard, EOGType, ICommonPageOGCardProps } from '@lemon8/web-app-shared/ssr';
import { ImageRegion } from '../constants';

export const ActivityOpenGraph = () => {
  const { region } = useAtomValue($Locale);
  const { title, description } = useActivityTDK();
  const image = ImageRegion[region] || ImageRegion.default;

  const ogCardInfo: ICommonPageOGCardProps = {
    ogUrl: `${url}?region=${region}`,
    ogTitle: title,
    ogDescription: description,
    ogMediaMetaInfo: {
      url: image,
      width: 1920,
      height: 1080,
    },
    // Temperately set all card as OG Article type
    ogType: EOGType.Article,
  };
  return <CommonPageOGCard {...ogCardInfo} />;
};
